import { Messages } from '../../codegen/Localize';
import { MetricErrorCode } from '../helpers/ErrorCodes';
import { MetricContentType } from '../models/ContentTypes';
import { IMetricInfo } from '../models/IMetricInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Module } from '../Module';
import { IErrorDetail } from './ContentActionNotification';
import { ContentUrlForItem } from './ContentUrl';

export class MetricErrors {

  constructor() { }

  public errorDetailsFor(metricErrorItem: IErrorItem<IMetricInfo>): IErrorDetail {
    return {
      itemName: metricErrorItem.item.name,
      itemUrl:
          metricErrorItem.error.code === MetricErrorCode.MetricNotFound
          ? null
          : ContentUrlForItem(metricErrorItem.item, MetricContentType),
      errorMessage: this.errorMessageFor(metricErrorItem)
    };
  }

  public errorMessageFor(errorItem: IErrorItem<IMetricInfo>) {
    const metric = errorItem.item;
    switch (errorItem.error.code) {
      case MetricErrorCode.MetricNotFound:
        return Messages.errorMetricNotFound({METRIC_NAME: metric.name});
      default:
        return Messages.errorUnknown();
    }
  }

}

Module.instance().service('MetricErrors', MetricErrors);
